import { render, staticRenderFns } from "./GroupStatisticTemplateForm.vue?vue&type=template&id=6c5b130f"
import script from "./GroupStatisticTemplateForm.vue?vue&type=script&lang=js"
export * from "./GroupStatisticTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports